export default __webpack_public_path__ + "static/cover-image-3279111c7ffa5720bab0d98f83b02aa0.jpg";